import dayjs from 'dayjs';
import { TestRun } from '../../types';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';

const resultsComparer = (a: TestRun, b: TestRun) => {
  const {
    passed: aPassed,
    warnings: aWarnings,
    errors: aErrors,
  } = a.test_runs.totals;
  const {
    passed: bPassed,
    warnings: bWarnings,
    errors: bErrors,
  } = b.test_runs.totals;

  const dateA = dayjs(a.metadata.latest_run_time, dateFormat);
  const dateB = dayjs(b.metadata.latest_run_time, dateFormat);

  if (aErrors !== bErrors) return bErrors - aErrors;
  if (aWarnings !== bWarnings) return bWarnings - aWarnings;
  if (aPassed !== bPassed) return bPassed - aPassed;

  return dateA.isBefore(dateB) ? 1 : dateA.isAfter(dateB) ? -1 : 0;
};

export default resultsComparer;
